export default __webpack_public_path__ + "static/media/agricultural-3.2a33e7ee.jpg";